import { useEffect } from "react";
import { initializePlayerState } from "@/stores/player/playerStore";

export const PlayerInitializer = () => {
  useEffect(() => {
    initializePlayerState();
  }, []);

  return null;
};
